/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';

import {AppSharedModule} from '../common/app-shared.module';
import {FieldsRoutePageComponent} from './fields-route-page.component';

@NgModule({
  imports: [AppSharedModule],
  declarations: [FieldsRoutePageComponent],
  exports: [FieldsRoutePageComponent]
})
export class FieldsModule {
}
